/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
    icon: {
            src: <svg xmlns='http://www.w3.org/2000/svg' width='165' height='110' viewBox='0 0 165 110' fill='none'>
<path d='M8.42912 25.3846C6.04087 25.3846 4.04036 24.5723 2.42759 22.9477C0.809196 21.3287 0 19.3205 0 16.9231C0 14.5256 0.809196 12.5146 2.42759 10.89C4.04036 9.27103 6.04087 8.46154 8.42912 8.46154H33.7165C36.1047 8.46154 38.108 9.27103 39.7264 10.89C41.3392 12.5146 42.1456 14.5256 42.1456 16.9231C42.1456 19.3205 41.3392 21.3287 39.7264 22.9477C38.108 24.5723 36.1047 25.3846 33.7165 25.3846H8.42912ZM8.42912 67.6923C6.04087 67.6923 4.04036 66.88 2.42759 65.2554C0.809196 63.6364 0 61.6282 0 59.2308C0 56.8333 0.809196 54.8223 2.42759 53.1977C4.04036 51.5787 6.04087 50.7692 8.42912 50.7692H33.7165C36.1047 50.7692 38.108 51.5787 39.7264 53.1977C41.3392 54.8223 42.1456 56.8333 42.1456 59.2308C42.1456 61.6282 41.3392 63.6364 39.7264 65.2554C38.108 66.88 36.1047 67.6923 33.7165 67.6923H8.42912ZM150.881 104.077L124.329 77.4231C120.958 79.8205 117.272 81.6172 113.27 82.8131C109.264 84.0146 105.223 84.6154 101.149 84.6154C89.4891 84.6154 79.5512 80.489 71.3356 72.2362C63.1144 63.989 59.0038 54.0128 59.0038 42.3077C59.0038 30.6026 63.1144 20.6236 71.3356 12.3708C79.5512 4.12359 89.4891 0 101.149 0C112.81 0 122.75 4.12359 130.972 12.3708C139.187 20.6236 143.295 30.6026 143.295 42.3077C143.295 46.3974 142.699 50.4533 141.508 54.4754C140.311 58.4918 138.519 62.1923 136.13 65.5769L162.682 92.2308C164.227 93.782 165 95.7564 165 98.1538C165 100.551 164.227 102.526 162.682 104.077C161.137 105.628 159.17 106.404 156.782 106.404C154.393 106.404 152.427 105.628 150.881 104.077ZM101.149 67.6923C108.174 67.6923 114.144 65.2244 119.061 60.2885C123.978 55.3526 126.437 49.359 126.437 42.3077C126.437 35.2564 123.978 29.2628 119.061 24.3269C114.144 19.391 108.174 16.9231 101.149 16.9231C94.1252 16.9231 88.1545 19.391 83.2375 24.3269C78.3206 29.2628 75.8621 35.2564 75.8621 42.3077C75.8621 49.359 78.3206 55.3526 83.2375 60.2885C88.1545 65.2244 94.1252 67.6923 101.149 67.6923ZM8.42912 110C6.04087 110 4.04036 109.188 2.42759 107.563C0.809196 105.944 0 103.936 0 101.538C0 99.141 0.809196 97.1328 2.42759 95.5138C4.04036 93.8892 6.04087 93.0769 8.42912 93.0769H75.8621C78.2503 93.0769 80.2536 93.8892 81.872 95.5138C83.4848 97.1328 84.2912 99.141 84.2912 101.538C84.2912 103.936 83.4848 105.944 81.872 107.563C80.2536 109.188 78.2503 110 75.8621 110H8.42912Z' fill='black'/>
</svg>
        },
	/**
	 * @see ./edit.js
	 */
	edit: Edit,

	/**
	 * @see ./save.js
	 */
	save,
} );
